/* HELIOS Desktop PDP bootstrap.
   Loaded on every device but does work ONLY on desktop (.helios-desktop).
   On desktop: clone the inert <template> body into #helios-desktop-host. Because
   <script> elements cloned from a <template> are INERT, we re-create them so they
   run. If any section uses <model-viewer>, inject the module once. On mobile it
   returns immediately, so the template stays inert and zero heavy assets are fetched. */
(function () {
  'use strict';

  // Scroll jump on return visits (Leo 2026-09-14): the desktop body mounts after load, so the browser's
  // automatic scroll restoration fires against the short pre-mount document and lands mid-page. On the
  // desktop layout we take restoration over: remember scrollY per URL on the way out, re-apply it after
  // the body is mounted. Mobile is untouched (its body is in the initial HTML, native restoration is fine).
  var SCROLL_KEY = 'helios-scroll:' + location.pathname;
  var isDesktopLayout = document.documentElement.classList.contains('helios-desktop');
  if (isDesktopLayout) {
    try { if ('scrollRestoration' in history) history.scrollRestoration = 'manual'; } catch (e) {}
    window.addEventListener('pagehide', function () {
      try { sessionStorage.setItem(SCROLL_KEY, String(window.scrollY || window.pageYOffset || 0)); } catch (e) {}
    });
  }
  function restoreScroll() {
    try {
      var nav = performance.getEntriesByType ? performance.getEntriesByType('navigation')[0] : null;
      var type = nav ? nav.type : '';
      var saved = sessionStorage.getItem(SCROLL_KEY);
      if (!saved || (type !== 'back_forward' && type !== 'reload')) return;
      var y = parseInt(saved, 10) || 0;
      requestAnimationFrame(function () { requestAnimationFrame(function () { window.scrollTo(0, y); }); });
    } catch (e) {}
  }

  function injectModelViewer() {
    if (document.getElementById('helios-mv-module')) return;
    var s = document.createElement('script');
    s.type = 'module';
    s.id = 'helios-mv-module';
    s.src = 'https://ajax.googleapis.com/ajax/libs/model-viewer/3.5.0/model-viewer.min.js';
    document.head.appendChild(s);
  }

  // Re-create cloned <script> nodes so they actually execute (cloned/inserted
  // scripts are inert per the HTML spec). Preserves order; runs inline + src.
  function activateScripts(container) {
    var olds = Array.prototype.slice.call(container.querySelectorAll('script'));
    olds.forEach(function (old) {
      var s = document.createElement('script');
      for (var i = 0; i < old.attributes.length; i++) {
        s.setAttribute(old.attributes[i].name, old.attributes[i].value);
      }
      if (old.src) { s.src = old.src; } else { s.text = old.textContent; }
      old.parentNode.replaceChild(s, old);
    });
  }

  function hydrate() {
    // Mount the desktop body only when the desktop layout is active (desktop UA + wide).
    // On a phone the class is never 'helios-desktop', so nothing heavy is ever fetched.
    if (!document.documentElement.classList.contains('helios-desktop')) return;
    var tpl = document.getElementById('helios-desktop-tpl');
    var host = document.getElementById('helios-desktop-host');
    if (!tpl || !host || host.dataset.hydrated) return;
    host.dataset.hydrated = '1';
    host.appendChild(tpl.content.cloneNode(true));
    if (host.querySelector('model-viewer')) injectModelViewer();
    activateScripts(host);
    if (window.HeliosDesktop && typeof window.HeliosDesktop.onHydrate === 'function') {
      window.HeliosDesktop.onHydrate(host);
    }
    restoreScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hydrate);
  } else {
    hydrate();
  }
  // If a desktop browser is widened from a narrow state (e.g. theme-editor desktop view,
  // or window resize past 750px), mount the desktop body on demand. Idempotent.
  window.addEventListener('resize', hydrate);
})();
